export default {
  callingAPI: false,
  callingAPIMessage: ''
}
